/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {EmptyResult} from './EmptyResult';
import {PageContainer} from './PageContainer';

export const Unauthorised = () => {
  return (
    <PageContainer title={'Uh-oh! You Don’t Have Access'}>
      <EmptyResult
        text={
          'It looks like you don’t have permission to view this area. Please reach out to your administrator if you believe this is a mistake.'
        }
      />
    </PageContainer>
  );
};
